<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ded"><img alt="Image" src="images/img01_1-3.png"/><br/>DEDICATION</h2>
<p class="indent">Very seldom does an author connect the dedication of the book to the contents. However, the dedication of this book is different. Many individuals have walked with me through the storms of my life, but two have been constant.</p>
<p class="indent">The first is the wife of my late brother. She has always been more of a sister than a sister-in-law. She is a woman of great strength, courage, and determination. She is known as a lover of people and an unequaled caregiver. Her counsel is wise and her heart is big. Thank you, Flo Jones Rowland, for forty plus years of friendship.</p>
<p class="indent">The second is a partner in the gospel. I first met this person in 1966, when she was working as a secretary and I as a young Bible professor. Her secretarial skills are unmatched, and more importantly, she has the courage of her convictions. As a friend she faithfully serves behind the scenes without fanfare or recognition. Her quiet walk with God is respected by all. Her serving heart is constant and consistent. Thank you, Peggie Baker, for thirty years of work, service, and friendship.<a id="page_v"></a></p><a id="page_v">
<p class="indent">I have never thanked these two women enough for their support through the years. It is my prayer that this dedication will communicate what I have not been able to say. I am reminded of a statement about the women in the ministry of Jesus:</p>
<p class="noindent">Some women were watching from a distance. Among them were Mary Magdalene, Mary the mother of James the younger and of Joses, and Salome. In Galilee these women had followed him and cared for his needs. (Mark 15:40-41)</p>
</a><p class="noindent"><a id="page_v">Thank you Flo and Peggie.</a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?35c96276